// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"aea8a5a6b6ce6da06d3b","6980":"af34574ce8e50ebf8cbe"}[chunkId] + ".js";
};